import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Spacer } from '@zillow/constellation';

import HRMixin from '../../themes/components/HR';

const HR = styled(Spacer)`
  ${HRMixin}
`;

HR.propTypes = {
  /** HR content */
  children: PropTypes.node,
  /** HR color */
  color: PropTypes.string,
};

HR.defaultProps = {
  color: 'gray400',
};

/** @component */
export default HR;
